export default "__VITE_ASSET__C0g8RFU8__"